<template>
  <div class="slide sidearm-mm-gallery relative">
    <div
      v-if="gallery"
      :style="{
        backgroundImage: `url('${gallery.images[0].large}?width=1920&height=1080&mode=crop&format=jpg&quality=80&anchor=topcenter')`
      }"
      class="sidearm-mm-gallery__background bg-size-cover h-100 absolute"
    ></div>
    <div
      class="sidearm-mm-gallery__content sidearm-mm-gallery__fade-in flex flex-align-stretch h-100 w-100 relative"
    >
      <div
        class="sidearm-mm-gallery__body text-white col-6-of-8 x-large-col-2-of-8 col-push-1 flex flex-column flex-justify-end x-large-flex-justify-center flex-align-start"
      >
        <h3
          class="sidearm-mm-gallery__decoration-heading type-heading-large mt-0 mb-1 hide-on-large-down"
        >
          Gallery
        </h3>

        <h4
          class="type-hero mt-0 mb-4"
          :class="{ '--long': gallery.title.length > 16 }"
        >
          {{ gallery.title }}
        </h4>
        <p class="type-paragraph-large mt-0 mb-2">
          {{ gallery.date | moment("MMMM DD, YYYY") }}
        </p>
        <a
          :href="`/galleries/?gallery=${gallery.id}`"
          target="_blank"
          class="sidearm-mm-btn --ghost"
          >See All Photos</a
        >
      </div>
    </div>
    <div
      class="sidearm-mm-gallery__divider sidearm-mm-gallery__divider--start sidearm-mm-gallery__fade-in col-1-of-8 absolute flex flex-justify-center hide-on-large-down"
    >
      <span></span>
    </div>
    <div
      class="sidearm-mm-gallery__divider sidearm-mm-gallery__divider--end col-1-of-8 absolute flex flex-justify-start hide-on-large-down"
    >
      <span></span>
    </div>
    <background-element
      class="sidearm-mm-gallery__top-background-element sidearm-mm-gallery__fade-in col-2-of-8 absolute"
    />
    <background-element
      class="sidearm-mm-gallery__bottom-background-element sidearm-mm-gallery__fade-in col-2-of-8 absolute"
    />
  </div>
</template>

<script>
import BackgroundElement from "@/components/Globals/BackgroundElement";

export default {
  name: "SlideGallery",

  props: {
    gallery: {
      type: Object,
      required: true
    },

    index: {
      type: Number,
      default: null
    }
  },

  components: {
    BackgroundElement
  },
  data: () => ({}),
  mounted() {}
};
</script>

<style lang="scss" scoped>
.sidearm-mm-gallery {
  transform: translateX(#{grid_percent(60)});
  &.active {
    transform: none;

    .sidearm-mm-gallery__bottom-background-element,
    .sidearm-mm-gallery__top-background-element {
      opacity: 1;
    }

    + .sidearm-mm-gallery {
      transform: translateX(-#{grid_percent(60)});

      .sidearm-mm-gallery__background {
        &::before {
          height: calc(#{grid_percent(120)} + #{$header-height});
          opacity: 1;
          transform: none;
        }
        &::after {
          height: grid_percent(120);
          opacity: 1;
          transform: none;
        }
      }
    }
  }
  &__fade-in {
    opacity: 1;
    transition: opacity 0.7s;
  }
  &__background {
    top: 0;
    left: 0;
    z-index: 1;
    transition: 0.7s;
    opacity: 0.3;
    background-position: top center;
    width: 100%;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    will-change: transform;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: calc(#{grid_percent(120)} + #{$header-height});
      content: "";
      background: $color-black;
      pointer-events: none;
      transition: transform 0.7s, opacity 0.7s, height 0.7s;
    }
    &::after {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: grid_percent(120);
      content: "";
      background: $color-black;
      pointer-events: none;
      transition: transform 0.7s, opacity 0.7s, height 0.7s;
    }
  }
  &__divider {
    top: calc(50% + #{$header-height/2});
    transform: translateY(-50%);
    z-index: 1;
    > span {
      display: inline-block;
      border-radius: 50%;
      border: 1px solid $color-white;
      display: block;
      height: 1.5rem;
      width: 1.5rem;
    }
    &--start {
      left: 0;
      &::before {
        width: calc(50% - 0.75rem);
        height: 1px;
        position: absolute;
        top: 50%;
        right: calc(50% + 0.75rem);
        content: "";
        background: $color-white;
      }
    }
    &--end {
      right: 0;
      transition: width 0.7s;
      width: 6.25%;
      span {
        &::before {
          transition: width 0.7s, left 0.7s;
        }
      }
      &::before {
        width: calc(100% - 1.5rem);
        height: 1px;
        position: absolute;
        top: 50%;
        left: 1.5rem;
        content: "";
        background: $color-white;
      }
    }
  }
  &__top-background-element {
    top: $header-height;
    left: 0;
    height: calc((100% - #{$header-height}) * 0.375);
    z-index: 1;
    opacity: 0;
    transition: opacity 0.7s;
  }
  &__bottom-background-element {
    bottom: 0;
    right: 12.5%;
    height: 50%;
    z-index: 1;
    opacity: 0;
    transition: opacity 0.7s;
  }
  &__content {
    z-index: 2;
  }
  &.active {
    .sidearm-mm-gallery__background {
      width: calc(100% - #{grid_percent(120)});
      transform: translateX(#{grid_percent(60)});
      &::before {
        opacity: 1;
        transform: translateY(-#{grid_percent(60)});
      }
      &::after {
        opacity: 1;
        transform: translateY(#{grid_percent(60)});
      }
    }
  }

  @media (max-width: #{$breakpoint-x-large}) {
    transform: initial;

    &.active {
      + .sidearm-mm-gallery {
        transform: initial;
      }

      .sidearm-mm-gallery__background {
        transform: initial;
        width: 100%;
      }
    }

    &__background {
      &::before,
      &::after {
        display: none;
      }
    }

    &__body {
      padding: 120px 0;
    }

    &__top-background-element {
      height: 25%;
      width: 100%;
    }

    &__bottom-background-element {
      height: 50%;
      width: 75%;
    }
  }
}
</style>
